<!DOCTYPE html>
@if (isSelectedSystem()) {
<div>
  <div class="ot-row">
    <div class="otsc-prop-header">
      <div class="ot-btn-group-left otsc-prop-header-btn">
        <ul class="ot-icon-group">
          <li>
            @if (!isEditing) {
            <button id="back-system-back-btn" aria-label="Back" i18n-title title="Back"
              class="ot-actions-header-icon otsc-icon-back" (click)="back()" i18n-title title="Back" i18n></button>
            }
          </li>
        </ul>
      </div>
      <h1 class="otsc-prop-header-text otsc-system-details-name" i18n>{{selectedSystem.systemName}}</h1>
      <div class="ot-btn-group otsc-prop-header-btn" style="height: 100%">
        <ul class="ot-icon-group">
          @if(selectedSystem.isAuthorized && !isSelectedSystemDisabled() && this.activeTab === SystemDetailTabs.GENERAL
          && isEditing){
          <li>
            <button id="save-agent-button" i18n-title title="Save" aria-label="Save" role="button"
              class="ot-actions-header-icon otsc-icon-save" (click)="saveSystem()"
              [disabled]="editSystemForm.invalid"></button>
          </li>
          }
          @if(selectedSystem.isAuthorized && !isSelectedSystemDisabled() && this.activeTab === SystemDetailTabs.GENERAL
          && isEditing){
          <li>
            <button id="cancel-edit-agent-button" i18n-title title="Cancel" aria-label="Cancel" role="button"
              class="ot-actions-header-icon otsc-icon-cancel" (click)="cancelEdit()"></button>
          </li>
          }
          @if(!selectedSystem.isAuthorized && this.solutionInfo?.environments.length != agent?.environments.length &&
          !isEditing) {
          <li>
            <button id="register-agent-button" i18n-title title="Register" aria-label="Register" role="button"
              class="ot-actions-header-icon otsc-icon-sprite-add" (click)="registerCurrentSystem()"></button>
          </li>
          }
          @if(selectedSystem.isAuthorized && !isSelectedSystemDisabled() && this.activeTab === SystemDetailTabs.GENERAL
          && !isEditing) {
          <li>
            <button id="edit-agent-button" i18n-title title="Edit system" aria-label="Edit System" role="button"
              class="ot-actions-header-icon ot-action-icon-edit-active otsc-icon-sprite-edit"
              (click)="editSystem()"></button>
          </li>
          }
          @if(selectedSystem.isAuthorized && !isSelectedSystemDisabled() && !isEditing) {
          <li>
            <button id="disable-agent-button" i18n-title title="Disable system" aria-label="Disable System"
              role="button" class="ot-actions-header-icon otsc-icon-sprite-lock"
              (click)="disableCurrentSystem()"></button>
          </li>
          }
          @if(selectedSystem.isAuthorized && isSelectedSystemDisabled() && !isEditing) {
          <li>
            <button id="enable-agent-button" i18n-title title="Enable system" aria-label="Enable System" role="button"
              class="ot-actions-header-icon otsc-icon-sprite-unlock" (click)="enableCurrentSystem()"></button>
          </li>
          }
          @if(selectedSystem.environments.length > 0 && !isEditing) {
          <li>
            <button id="unregister-agent-button" i18n-title title="Unregister system" aria-label="Unregister System"
              role="button" class="ot-actions-header-icon otsc-icon-sprite-move"
              (click)="unRegisterCurrentSystem()"></button>
          </li>
          }
          @if(!selectedSystem.isAuthorized && !isEditing) {
          <li>
            <button id="remove-agent-button" i18n-title title="Remove system" aria-label="Remove System" role="button"
              class="ot-actions-header-icon otsc-icon-sprite-delete" (click)="removeCurrentSystem()"></button>
          </li>
          }
        </ul>
      </div>
    </div>
  </div>
</div>
}
@if (isSelectedSystem()) {
<div>
  <div id="system-details-body">
    <div class="ot-panel__header">
      <app-tabs [identifier]="'system-details-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="tabs"
        [color]="TabColor.PRIMARY" [selectedIndex]="activeTab"></app-tabs>
    </div>
    <div #systemdetailsarea id="system-details-area" style="height: calc(100vh - 206px)">
      <ng-scrollbar>
        @if (activeTab == SystemDetailTabs.GENERAL) {
        <div id="general-tab-content" class="otsc-details-tab-section">
          <form [formGroup]="editSystemForm" name="otsc-edit-system-form">
            <div class="ot-row">
              <span class="otsc-tab-title" i18n>General</span>
            </div>
            @if (selectedSystem.isAuthorized) {
            <div class="ot-row">
              <div class="ot-row__column otsc-metadata-key">
                <span class="ot--has-text-muted" i18n>Name</span>
              </div>
              <div class="ot-row__column otsc-metadata-value">
                @if (!isEditing) {
                <p id="system-name">{{selectedSystem.nickName}}</p>
                }
                @if (isEditing) {
                <div class="ot-form-control"
                  [ngClass]="{'ot-form-control--is-invalid' : nickNameFormCtrl.touched && nickNameFormCtrl.invalid}">
                  <input id="edit-system-name" name="systemName" type="text" formControlName="nickNameFormCtrl"
                    i18n-placeholder placeholder="System Name" class="ot-input otsc-edit-system-ctrl" maxlength="50">
                  @if (nickNameFormCtrl.touched && nickNameFormCtrl.invalid && nickNameFormCtrl.errors.required) {
                  <p id="requiredNickNameErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                    Name cannot be empty.
                  </p>
                  }
                  @if (nickNameFormCtrl.errors && nickNameFormCtrl.errors.agentNameExists) {
                  <p id="nickNameExistsErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                    Name already exists.
                  </p>
                  }
                </div>
                }
              </div>
            </div>
            }
            <div class="ot-row">
              <div class="ot-row__column otsc-metadata-key">
                <span class="ot--has-text-muted" i18n>Host</span>
              </div>
              <div class="ot-row__column otsc-metadata-value">
                <p id="host-name">{{selectedSystem.systemName}}</p>
              </div>
            </div>
            <div class="ot-row">
              <div class="ot-row__column otsc-metadata-key">
                <span class="ot--has-text-muted" i18n>Status</span>
              </div>
              <div class="ot-row__column otsc-metadata-value">
                <i id="status-icon" class="otsc-status-icon" style="margin-bottom: 8px;" [title]="agentStatus.altText"
                  [ngClass]="agentStatus.className" [ngClass]="agentStatus.className"></i>
              </div>
            </div>
            @if (selectedSystem.isAuthorized) {
            <div class="ot-row">
              <div class="ot-row__column otsc-metadata-key">
                <span class="ot--has-text-muted"
                  [ngClass]="{'otsc-empty-description' : selectedSystem.description == ''}" i18n>Description</span>
              </div>
              <div class="ot-row__column otsc-metadata-value">
                @if (!isEditing) {
                <p id="system-description">{{selectedSystem.description}}</p>
                }
                @if (isEditing) {
                <textarea id="edit-system-description" class="ot-textarea otsc-edit-system-ctrl" rows="3"
                  formControlName="descriptionFormCtrl" minlength="1" maxlength="300" id="edit-system-description"
                  [value]="description" i18n-placeholder placeholder="System description"></textarea>
                }
              </div>
            </div>
            }
            @if (selectedSystem.isAuthorized) {
            <div class="ot-row">
              <div class="ot-row__column otsc-metadata-key">
                <span class="ot--has-text-muted" [ngClass]="{'otsc-edit-drop-down-label' : isEditing}" i18n>Log
                  level</span>
              </div>
              <div class="ot-row__column otsc-metadata-value">
                @if (!isEditing) {
                <p id="system-log-level">{{getLogLevelName(selectedSystem.logLevel)}}</p>
                }
                @if (isEditing) {
                <div class="ot-select otsc-edit-system-ctrl">
                  <select id="edit-system-log-level" formControlName="logLevelFormCtrl" i18n-aria-label
                    aria-label="Select log level" (change)="validateName()">
                    @for (level of logLevels; track level) {
                    <option [ngValue]="level.value">
                      {{ level.name }}
                    </option>
                    }
                  </select>
                </div>
                }
              </div>
            </div>
            }
            @if (selectedSystem.isAuthorized) {
            <div class="ot-row">
              <div class="ot-row__column otsc-metadata-key">
                <span class="ot--has-text-muted" [ngClass]="{'otsc-edit-drop-down-label' : isEditing}" i18n>HTTP log
                  level</span>
              </div>
              <div class="ot-row__column otsc-metadata-value">
                @if (!isEditing) {
                <p id="system-http-log-level">{{getHttpLogLevelName(selectedSystem.httpLogLevel)}}</p>
                }
                @if (isEditing) {
                <div class="ot-select otsc-edit-system-ctrl">
                  <select id="edit-system-http-log-level" formControlName="httpLogLevelFormCtrl" i18n-aria-label
                    aria-label="Select http log level" (change)="validateName()">
                    @for (level of httpLogLevels; track level) {
                    <option [ngValue]="level.value">
                      {{ level.name }}
                    </option>
                    }
                  </select>
                </div>
                }
              </div>
            </div>
            }
            <div class="ot-row">
              <div class="ot-row__column otsc-metadata-key">
                <span class="ot--has-text-muted" i18n>Connected</span>
              </div>
              <div class="ot-row__column otsc-metadata-value">
                <p id="system-connected-time">{{selectedSystem.updatedDateTime | fromNow}}</p>
              </div>
            </div>
            @if (selectedSystem.isAuthorized) {
            <div class="ot-row">
              <div class="ot-row__column otsc-metadata-key">
                <span class="ot--has-text-muted" i18n>Registered</span>
              </div>
              <div class="ot-row__column otsc-metadata-value">
                <p id="system-registered-time">{{selectedSystem.approvedDateTime | fromNow}}</p>
              </div>
            </div>
            }
            @if (selectedSystem.isAuthorized) {
            <div class="ot-row">
              <div class="ot-row__column otsc-metadata-key">
                <span class="ot--has-text-muted" i18n>Registered by</span>
              </div>
              <div class="ot-row__column otsc-metadata-value">
                <p id="system-registered-by">{{selectedSystem.approvedUserFirstName +
                  selectedSystem.approvedUserLastName}}</p>
              </div>
            </div>
            }
            <div class="ot-row">
              <div class="ot-row__column otsc-metadata-key">
                <span class="ot--has-text-muted" i18n>Installation path</span>
              </div>
              <div class="ot-row__column otsc-metadata-value">
                <p id="system-install-path">{{selectedSystem.installPath}}</p>
              </div>
            </div>
            <div class="ot-row">
              <div class="ot-row__column otsc-metadata-key">
                <span class="ot--has-text-muted" i18n>JRE version</span>
              </div>
              <div class="ot-row__column otsc-metadata-value">
                <p id="system-jre-version">{{selectedSystem.jreVersion}}</p>
              </div>
            </div>
          </form>
        </div>
        }
        @if (activeTab === SystemDetailTabs.PRODUCTS) {
        <div #productdetailstablecontainer id="products-tab-content" class="otsc-details-tab-section">
          <div class="ot-row">
            <span class="otsc-tab-title" i18n>Products</span>
          </div>
          <div class="ot-row">
            <p i18n>List of Component Instances discovered on the System. A supported Product can be patched or updated
              by System
              Center. Enable a Product to begin patching it.</p>
          </div>
          <div class="ot-row" style="padding-bottom: 10px;">
            @if (selectedSystem.isAuthorized) {
            <button id="system-discover-products-button" role="button" title="Discover products"
              class="ot-btn ot-btn--is-primary" [disabled]="!selectedSystem.isOnline || isSelectedSystemDisabled()"
              (click)="openDiscoverProducts()" i18n>
              Discover products
            </button>
            }
            @if (selectedSystem.isAuthorized) {
            <button id="system-manual-discover-products-button" role="button" title="Discover products manually"
              class="ot-btn ot-btn--is-secondary ot-ml-1"
              [disabled]="!selectedSystem.isOnline || isSelectedSystemDisabled()" (click)="startManualDiscover()" i18n>
              Manual discover
            </button>
            }
          </div>
          <app-datatable [identifier]="'system-details-products-table'" [cols]="productDataColumns" [rows]="products"
            [scroll]="false" (actionmenuevent)="actionMenuClicked($event)" [showcheckboxes]="true"></app-datatable>
        </div>
        }
        @if (activeTab === SystemDetailTabs.ENVIRONMENTS) {
        <div id="environments-tab-content" class="otsc-details-tab-section">
          <div class="ot-row">
            <span class="otsc-tab-title" i18n>Environments</span>
          </div>
          <div class="ot-row">
            <p i18n>This system manages the listed environments. To unregister it from a single environment, simply use
              the inline menu. <br /> For product management, switch to the corresponding environment.</p>
          </div>
          @if(selectedSystem.isAuthorized) {
          <div class="ot-row" style="padding-bottom: 10px;">
            <button id="system-add-environment-button" role="button" title="Add Environment"
              class="ot-btn ot-btn--is-primary" [disabled]="!selectedSystem.isOnline || isSelectedSystemDisabled()"
              (click)="registerCurrentSystem()" i18n>
              Add Environments
            </button>
          </div>
          }
          <app-datatable [identifier]="'system-details-environments-table'" [cols]="environmentsColumns"
            [rows]="environments" [scroll]="false" (actionmenuevent)="actionMenuClicked($event)"
            [showcheckboxes]="true"></app-datatable>
        </div>
        }
        @if (activeTab === SystemDetailTabs.NETWORKING) {
        <div id="network-tab-content" class="otsc-details-tab-section">
          <div class="ot-row">
            <span class="otsc-tab-title" i18n>Networking</span>
          </div>
          <div class="ot-row">
            <div class="ot-row__column otsc-metadata-key">
              <span class="ot--has-text-muted" i18n>Physical address</span>
            </div>
            <div class="ot-row__column otsc-metadata-value">
              <p id="system-physical-address">{{selectedSystem.macAddress}}</p>
            </div>
          </div>
          <div class="ot-row">
            <div class="ot-row__column otsc-metadata-key">
              <span class="ot--has-text-muted" i18n>IPv4</span>
            </div>
            <div class="ot-row__column otsc-metadata-value">
              <p id="system-ipv4-address" [innerHTML]="getINetAddressString(selectedSystem.ipv4)"></p>
            </div>
          </div>
          <div class="ot-row">
            <div class="ot-row__column otsc-metadata-key">
              <span class="ot--has-text-muted" i18n>IPv6</span>
            </div>
            <div class="ot-row__column otsc-metadata-value">
              <p id="system-ipv6-address" [innerHTML]="getINetAddressString(selectedSystem.ipv6)"></p>
            </div>
          </div>
        </div>
        }
        @if (activeTab === SystemDetailTabs.OPERATINGSYSTEM) {
        <div id="operating-system-tab-content" class="otsc-details-tab-section">
          <div class="ot-row">
            <span class="otsc-tab-title" i18n>Operating System</span>
          </div>
          <div class="ot-row">
            <div class="ot-row__column otsc-metadata-key">
              <span class="ot--has-text-muted" i18n>Operating system</span>
            </div>
            <div class="ot-row__column otsc-metadata-value">
              <p id="system-os-value" i18n>{{selectedSystem.osName}}, internal {{selectedSystem.osVersion}}</p>
            </div>
          </div>
          @if (selectedSystem.isOnline && selectedSystem.isAuthorized && selectedSystem.isActive) {
          <div class="ot-row">
            <div class="ot-row__column otsc-metadata-key">
              <span class="ot--has-text-muted" i18n>CPU</span>
            </div>
            <div class="ot-row otsc-metadata-value">
              <div id="cpu-chart" class="ot-carousel__element otsc-cpu-chart">
                <canvas id="otsc-chart-cpu" baseChart [data]="cpuChartData" [options]="cpuChartOptions"
                  [type]="cpuChartType"></canvas>
              </div>
            </div>
          </div>
          }
          @if (selectedSystem.isOnline && selectedSystem.isAuthorized && selectedSystem.isActive) {
          <div class="ot-row">
            <div class="ot-row__column otsc-metadata-key" style="margin-right: 50px;">
              <span class="ot--has-text-muted" i18n>Memory</span>
            </div>
            <div class="otsc-row__column otsc-metadata-value">
              <div id="memory-chart" class="ot-carousel__element otsc-resource-chart">
                <canvas height="175" id="otsc-chart-memory" baseChart [data]="memoryChartData"
                  [options]="memoryChartOptions" [type]="memoryChartType"></canvas>
              </div>
            </div>
            <div class="otsc-metadata-key" style="margin-left: 50px;">
              <span class="ot--has-text-muted" i18n>Disk</span>
            </div>
            <div class="otsc-row__column otsc-metadata-value">
              <div id="disk-chart" class="ot-carousel__element otsc-resource-chart">
                <canvas height="175" id="otsc-chart-disk" baseChart [data]="diskChartData" [options]="diskChartOptions"
                  [type]="diskChartType"></canvas>
              </div>
            </div>
          </div>
          }
        </div>
        }
      </ng-scrollbar>
    </div>
  </div>
</div>
}